import { createSlice } from '@reduxjs/toolkit';

const apiTrackerSlice = createSlice({
  name: 'apiTracker',
  initialState: {
    pendingRequestMap: {} as Record<string, boolean>,
  },
  reducers: {
    apiPending: (state, action) => {
      const temp = { ...state.pendingRequestMap, [action.payload]: true };
      state.pendingRequestMap = temp;
    },
    apiSettled: (state, action) => {
      delete state.pendingRequestMap[action.payload];
    },
  },
});

export const { apiPending, apiSettled } = apiTrackerSlice.actions;
export const apiTrackerReducer = apiTrackerSlice.reducer;
